import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const keySlice = createSlice({
  name: "category",
  initialState: {
    stripeKeys: {},
    refetch: false,
  },
  reducers: {
    getStripeKeysSuccess: (state, action) => {
      state.stripeKeys = action.payload;
    },
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
  },
});

export const { getStripeKeysSuccess, refetch } = keySlice.actions;

export const getStripeKeys = (setIsLoading) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/keys/admin/get/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(getStripeKeysSuccess(data.data));
    setIsLoading(false);
  } catch (error) {
    console.log(error);
    setIsLoading(false);
  }
};

export const updateKeys = (id, payload, setIsLoading) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${process.env.REACT_APP_API_BASE_URL}/keys/update/${id}/v1`;
    const { data } = await axios.put(url, payload, {
      headers: { Authorization: localStorage.getItem("sgtoken") },
    });
    setIsLoading(false);
    dispatch(refetch(true));
    toast.success(data.message, {
      position: "top-center",
      autoClose: 5000,
    });
  } catch (error) {
    console.log(error);
    setIsLoading(false);
  }
};

export default keySlice.reducer;
